import React  , { useContext  } from 'react'; 

import   'scss/components/page-components/Layout/Navbar.scss';
import {     Link  , useNavigate } from "react-router-dom";
import AppContext from  'js/Contexts/App.js'; 
import { useTranslate2 } from 'js/components/helpers/Translate.js';
import { produce } from 'immer';
import UserDropDown from 'js/components/page-components/Layout/Navbar/UserDropDown.js';
import IconButton from '@mui/material/IconButton';
import SettingsDropdown from 'js/components/page-components/Layout/Navbar/SettingsDropdown.js';
import AppsDropdown from 'js/components/page-components/Layout/Navbar/AppsDropdown.js';


const Navbar = ({ setShowSideBar }) => {
    const appContext = useContext(AppContext);
    const { layoutTranslations } = appContext;
    const translate = useTranslate2(layoutTranslations?.translations || {});
    
    const setUserDropDownOpen = (open)=>{
        appContext.setMainLayoutState(produce( appContext.mainLayoutState , draft => {
            draft.userDropwDownOpen = open;
        }));
    }

    let currentUser = appContext.authService.getCurrentIdentity()?.user;
    let availableAccounts = [];
    if( currentUser && currentUser.managingAccounts && currentUser.managingAccounts.length > 0 ){
        availableAccounts = currentUser.managingAccounts;
    }
    if( currentUser && currentUser.managingSuppliers && currentUser.managingSuppliers.length > 0 ){
        availableAccounts = currentUser.managingSuppliers;
    }

    const currentAccount = appContext.appReducer.getCurrentAccountWithData();

    const openSidebar = () => {
        setShowSideBar(true);
    };

    const closeSidebar = () => {
        setShowSideBar(false);
    };
    
    return  (
    <div className='L_Navbar'>
            {! currentUser && <div className="navItemsLeft"><span className='currentApp'>
                        <Link to={'a/ac/' + currentAccount?.id + '/sample-approvals'} >
                            <img className="currentAppLogo" src="/img/logos/ordercollab-favicon_32x32.png" />
                            <h3>OrderCollab</h3>
                        </Link>
                    </span> </div>
            }
            {
            currentUser && <div className="navItemsLeft">
                {appContext.mainLayoutState.foldOutOpen &&
                <IconButton aria-label="close sidebar" onClick={closeSidebar} size="small">
                    <img src="/icon/layout/sidebar-close-icon-dark.svg" className="sidebarCloseIcon" onClick={closeSidebar} />
                </IconButton>
                }
                {!appContext.mainLayoutState.foldOutOpen &&
                    <IconButton aria-label="open sidebar" onClick={openSidebar} size="small">
                    <img src="/icon/layout/sidebar-open-icon-dark.svg" className="sidebarOpenIcon" onClick={openSidebar} />
                </IconButton>
                }
                <AppsDropdown />
                    {/* <span className='currentApp'>
                        <Link to={'a/ac/' + currentAccount?.id + '/sample-approvals'} >
                            <img className="currentAppLogo" src="/img/logos/ordercollab-favicon_48x48.png" />
                            <h3>OrderCollab</h3>
                        </Link>
                    </span> */}
                    <span className='currentApp'>
                        <Link to={'a/ac/' + currentAccount?.id + '/sample-approvals'} >
                            <img className="currentAppLogo" src="/img/logos/sample-approvals-logo.png" />
                            <h3>Sample Approvals</h3>
                        </Link>
                    </span>
                   
            </div>
            }

       <div className="navItemsRight">
        {
            currentUser && window.innerWidth > 768 && <SettingsDropdown />
        }
        {
            currentUser &&
            <UserDropDown setUserDropDownOpen={setUserDropDownOpen} />
        } 
         { !currentUser && <>
         <Link className="PC_Navbar_LoginLink" to="/a/login">{translate('login' , 'login') }</Link> 
         <Link className="PC_Navbar_RegisterLink" to="/a/register">{translate('register' , 'register') }</Link>
         </>} 
        </div>
    </div> 

    );
}

export default Navbar;
